(function () {
  const STORAGE_KEY = "wholesale_saved_cart_v1";

  async function addItems(items) {
    // Add items sequentially to avoid rate limits / race conditions
    for (const item of items) {
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: item.id,
            quantity: item.quantity,
            properties: item.properties || undefined
          })
        });
      } catch (e) {
        // keep going
      }
    }
  }

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) return null;
    return await res.json();
  }

  async function restoreIfNeeded() {
    // This flag is set from Liquid (see theme.liquid snippet below)
    if (!window.__IS_WHOLESALE_PARTNER__) return;

    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return;

    let saved;
    try { saved = JSON.parse(raw); } catch (e) { return; }
    if (!saved?.items?.length) return;

    // Only restore if cart is currently empty (prevents duplicates)
    const cart = await getCart();
    if (!cart) return;
    if ((cart.items || []).length > 0) return;

    await addItems(saved.items);

    // Clear saved copy after restore to prevent re-adding next load
    localStorage.removeItem(STORAGE_KEY);

    // Refresh so cart drawer/mini-cart updates
    window.location.reload();
  }

  restoreIfNeeded();
})();